// The ferry and the public airship going about their timetable (shared/routes.ts), drawn on the overworld at
// overworld size, and as little icons on the minimap and the world map.
import ink from '../ink/ink.js';
import { drawAirship, SHIP_LIFT } from './inkchar.js';
import type { VesselView } from '../../../shared/routes.js';

const I = ink as any;
const { INK, oval, line, poly, blob } = I;
const K = 3;

/** A little ferry with a sail, rocking on the water, with a wake while it's moving. */
function drawFerry(g: CanvasRenderingContext2D, x: number, y: number, ang: number, moving: boolean, now: number, k = 0.62): void {
  const t = now / 1000, rock = Math.sin(t * 2.1) * 0.06, face = Math.cos(ang) < 0 ? -1 : 1;
  // the wake: two fading lines behind it
  if (moving) {
    const bx = -Math.cos(ang), by = -Math.sin(ang);
    for (let i = 1; i <= 3; i++) {
      const a = 0.35 - i * 0.09, d = (10 + i * 7) * k * 2;
      g.strokeStyle = `rgba(255,255,255,${a})`; g.lineWidth = 1.2;
      g.beginPath(); g.ellipse(x + bx * d, y + 2 + by * d * 0.6, (4 + i * 3) * k * 2, (1.4 + i * 0.5) * k * 2, ang, 0, Math.PI * 2); g.stroke();
    }
  }
  g.save(); g.translate(x, y); g.rotate(rock); g.scale(face * k / K * 2, k / K * 2);
  g.fillStyle = 'rgba(62,47,40,0.18)'; g.beginPath(); g.ellipse(0, 6, 40, 7, 0, 0, Math.PI * 2); g.fill();
  // the hull
  blob(g, [[-40, -6], [38, -6], [46, -12], [34, 8], [-30, 8], [-42, 0]], '#9b7653', 9500, 2.2, 0.4);
  line(g, [[-40, -6], [42, -6]], 9501, 2.2, INK);
  for (const px of [-24, -6, 12]) oval(g, px, 0, 3.4, 3.4, '#f4efe4', 9502 + px, 1.4, 8);   // portholes
  // the cabin and the mast
  poly(g, [[-22, -6], [4, -6], [4, -20], [-22, -20]], '#e9dcc0', 9510, 2);
  poly(g, [[-25, -20], [7, -20], [2, -26], [-20, -26]], '#4e83ad', 9511, 2);
  line(g, [[14, -6], [14, -62]], 9512, 2.4, INK);
  blob(g, [[16, -60], [40, -14], [16, -12]], '#fbf7ee', 9513, 2, 0.3);
  line(g, [[20, -44], [32, -20]], 9514, 1.2, 'rgba(62,47,40,0.35)');
  poly(g, [[14, -62], [26, -58], [14, -54]], '#e3604b', 9515, 1.4);   // the pennant
  g.restore();
}

/** Draw one vessel at its spot (game pixels): the ferry on the water, the airship up in the sky with its shadow. */
export function drawVessel(g: CanvasRenderingContext2D, v: VesselView, x: number, y: number, now: number): number {
  if (v.kind === 'ship') { drawFerry(g, x, y, v.ang, !v.docked, now); return y - 24; }
  const dir = Math.cos(v.ang) < 0 ? 3 : 1, k = 0.5;
  drawAirship(g, x, y, SHIP_LIFT + 14, dir, now, 'back', k);
  drawAirship(g, x, y, SHIP_LIFT + 14, dir, now, 'front', k);
  return y - (SHIP_LIFT + 14) * k - 168 * k / 3;
}

/** A tiny icon for the minimap (pixels): a boat or a balloon. */
export function miniVessel(c: CanvasRenderingContext2D, v: VesselView, x: number, y: number): void {
  c.fillStyle = '#2f2a26';
  if (v.kind === 'ship') { c.fillRect(x - 3, y, 7, 3); c.fillRect(x, y - 4, 1, 4); c.fillStyle = '#fbf7ee'; c.fillRect(x + 1, y - 4, 2, 3); c.fillStyle = '#9b7653'; c.fillRect(x - 2, y + 1, 5, 1); }
  else { c.beginPath(); c.arc(x, y - 2, 3.5, 0, Math.PI * 2); c.fill(); c.fillStyle = '#e3604b'; c.beginPath(); c.arc(x, y - 2, 2.5, 0, Math.PI * 2); c.fill(); c.fillStyle = '#2f2a26'; c.fillRect(x - 2, y + 2, 5, 2); }
}
